export default __webpack_public_path__ + "static/media/bannerFeiraoCarnaval4.3851dcce.jpg";